<template>
  <div>

    <c-title>Ihr Account ist nicht verifiziert</c-title>

    <p>Wir haben einen Nachricht an Ihre E-Mail-Adresse mit einem Bestätigungslink geschickt. Mit diesem Link können Sie Ihren Account verifizieren. Wenn Sie keine E-Mail bekommen haben, können Sie einen neuen Link anfordern.</p>

    <c-resend-verification
      v-if="resendEmail"
      ref="form"
    />

    <c-button
      v-if="!resendEmail"
      @click="showResend"
    >
      E-Mail erneut versenden
    </c-button>

    <c-button
      v-else
      @click="resendEmail = false"
    >
      Abbrechen
    </c-button>

    <c-button @click="$router.push({ name: 'login' })">
      Zurück zum Login
    </c-button>

  </div>
</template>

<script>
import CTitle from '@/components/CTitle'
import CButton from '@/components/CButton'
import CResendVerification from '@/components/CResendVerification'

export default {
  name: 'VUnverified',

  components: {
    CTitle,
    CButton,
    CResendVerification
  },

  data () {
    return {
      resendEmail: false
    }
  },

  methods: {
    showResend () {
      this.resendEmail = true
      this.$nextTick(() => {
        this.$refs.form.$refs.input.focus()
      })
    }
  }
}
</script>
